import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MemberDetailsFormPage } from './member-details-form.page';

const routes: Routes = [
  {
    path: '',
    component: MemberDetailsFormPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MemberDetailsFormPageRoutingModule {}
